const meta = (globalThis as unknown as { import?: { meta?: { env?: { MODE?: string } } } }).import?.meta;

export const ENVIRONMENT =
  meta?.env?.MODE ??
  process.env.NODE_ENV ??
  "development";
console.log(`Environment: ${ENVIRONMENT}`);
export const IS_DEV = ENVIRONMENT === "development";
